import { useMemo } from "react";
import { ListOffer } from "../../../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import TeslaEvCharger from "../../../assets/images/tesla-ev-charger-img.svg";
import {
  CardItem,
  TwoColumnLayout,
  OfferCardBody,
  NonSolarHeader,
  // eslint-disable-next-line import/no-restricted-paths
} from "./OfferCardCommon";

import { STANDALONE_EV_CHARGER_PRODUCT_ID } from "constants/bundleAndProductIds";

const EvChargerOnlyContent = ({
  offer,
  financing,
  isMobile,
  isTablet,
}: {
  offer: ListOffer;
  financing: string;
  isMobile: boolean;
  isTablet: boolean;
}) => {
  const nonSolarEvChargerCount = useMemo(() => {
    return (
      offer.products.filter((item) => {
        return item?.productId === STANDALONE_EV_CHARGER_PRODUCT_ID;
      })[0]?.count || 1
    );
  }, [offer]);

  const getEvChargerOnlyHeaderText = (nonSolarEvChargerCount: number) => {
    return nonSolarEvChargerCount === 1 ? " EV charger" : " EV chargers";
  };
  return (
    <>
      <NonSolarHeader
        testId="non-solar-ev-charger-header"
        isMobile={isMobile}
        isTablet={isTablet}
        src={TeslaEvCharger}
        alt="Tesla EV Charger"
        title="EV charger"
        count={
          nonSolarEvChargerCount +
          getEvChargerOnlyHeaderText(nonSolarEvChargerCount)
        }
      />
      <OfferCardBody>
        <TwoColumnLayout>
          {financing && (
            <CardItem title="Financing" value={financing} testId="financing" />
          )}
          {offer?.evChargerManufacturer && (
            <CardItem
              title="EV charger Type"
              value={offer.evChargerManufacturer}
              testId="ev-charger-type"
            />
          )}
          {offer?.maxChargeRateInA && (
            <CardItem
              title="Max charge rate"
              value={offer.maxChargeRateInA + " Amps"}
              testId="max-charge-rate"
            />
          )}
          {offer?.powerFlowMode && (
            <CardItem
              title="Charging cap."
              value={offer.powerFlowMode}
              testId="charging-cap"
            />
          )}
          {nonSolarEvChargerCount && (
            <CardItem
              title="EV chargers"
              value={nonSolarEvChargerCount}
              testId="ev-charger"
            />
          )}
        </TwoColumnLayout>
      </OfferCardBody>
    </>
  );
};

export { EvChargerOnlyContent };
